import React from "react";

const COLORS = ["text-midBrown", "text-lightBrown", "text-brown"];

export default function ColoredTitle({ text, className = "" }) {
  return (
    <span className={className}>
      {text.split("").map((char, i) => (
        <span key={i} className={char === " " ? "" : COLORS[i % 3]}>
          {char}
        </span>
      ))}
    </span>
  );
}
